import { render, staticRenderFns } from "./SiteTypes.vue?vue&type=template&id=37e18244&scoped=true&"
import script from "./SiteTypes.vue?vue&type=script&lang=js&"
export * from "./SiteTypes.vue?vue&type=script&lang=js&"
import style0 from "./SiteTypes.vue?vue&type=style&index=0&id=37e18244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e18244",
  null
  
)

component.options.__file = "SiteTypes.vue"
export default component.exports